var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "selfExamination" }, [
      _c("div", { staticClass: "top" }, [
        _c("img", {
          staticClass: "selfExamination-img",
          attrs: {
            src: require("../../../assets/images/degreeApplication/selfExamination.png"),
            alt: "",
          },
        }),
      ]),
      _c("div", { staticClass: "cont" }, [
        _c("h1", { staticClass: "cont-title" }, [_vm._v("申报条件简述 ")]),
        _c("div", { staticClass: "cont-item cont-top" }, [
          _vm._v(" 成人高等教育本科毕业生在 "),
          _c("span", { staticClass: "color-red" }, [
            _vm._v(" 毕业后（以毕业证书落款时间为准）两年内 "),
          ]),
          _vm._v(" ，对照下列条件后可向继续教育学院提出申请学士学位的申报。 "),
        ]),
        _c("div", { staticClass: "cont-item cont-1" }, [
          _vm._v(
            " （一）坚持四项基本原则，热爱社会主义祖国，遵纪守法，品行端正。 "
          ),
        ]),
        _c("div", { staticClass: "cont-item" }, [
          _vm._v(
            " （二）完成本科教学计划的各项要求，能较好地掌握本专业规定的公共课、基础理论课、专业基础课、专业课和基本技能，具有从事科学研究工作或担任专门技术工作的能力，经考核准予毕业。 "
          ),
        ]),
        _c("div", { staticClass: "cont-item" }, [
          _vm._v(
            " （三）非英语专业本科生通过各省市学位主管部门组织的成人高等教育学士学位外语水平统一考试（2020年1月1日前）；或者自2020年1月1日起通过 "
          ),
          _c("span", { staticClass: "color-red" }, [
            _vm._v("以下五种考试之一"),
          ]),
          _vm._v(" ： "),
        ]),
        _c("div", { staticClass: "cont-item cont-3" }, [
          _c("p", [
            _vm._v(" 1.全国大学英语 "),
            _c(
              "a",
              { attrs: { href: "http://cet.neea.edu.cn/", target: "_blank" } },
              [_c("span", { staticClass: "color-blue" }, [_vm._v("四级考试")])]
            ),
            _vm._v(" （简称CET）CET-4成绩355分及以上；  "),
          ]),
          _c("p", [
            _vm._v(" 2.全国 "),
            _c(
              "a",
              { attrs: { href: "http://pets.neea.edu.cn/", target: "_blank" } },
              [
                _c("span", { staticClass: "color-blue" }, [
                  _vm._v("英语等级考试（简称PETS）"),
                ]),
              ]
            ),
            _vm._v(" PETS-3笔试成绩60分及以上；  "),
          ]),
          _c("p", [
            _vm._v(
              " 3.高等教育自学考试本科段统考课程英语（二）成绩60分及以上；  "
            ),
          ]),
          _c("p", [
            _vm._v(" 4.国际人才英语考试（简称ETIC）ETIC初级成绩良好及以上。 "),
          ]),
          _c("p", [_vm._v(" 5.全国计算机等级考试（简称NCRE ）二级及以上。 ")]),
        ]),
        _c("div", { staticClass: "cont-item" }, [
          _vm._v(" （四）业余及 "),
          _c("span", { staticClass: "color-red" }, [_vm._v("函授本科层次")]),
          _vm._v(" 学生在校学习期间课程 "),
          _c("span", { staticClass: "color-red" }, [_vm._v("平均成绩在75分")]),
          _vm._v(" 及以上，高等教育 "),
          _c("span", { staticClass: "color-red" }, [_vm._v("自学考试本科")]),
          _vm._v(" 学生课程 "),
          _c("span", { staticClass: "color-red" }, [_vm._v("平均成绩在65分")]),
          _vm._v(" 及以上。 "),
        ]),
        _c("div", { staticClass: "cont-item" }, [
          _vm._v(" （五） "),
          _c("span", { staticClass: "color-red" }, [
            _vm._v("毕业论文、毕业设计"),
          ]),
          _vm._v(" 或其他毕业实践环节成绩 "),
          _c("span", { staticClass: "color-red" }, [_vm._v("达到良好及以上")]),
          _vm._v(" （75分及以上）。 "),
        ]),
        _c("div", { staticClass: "cont-item" }, [
          _vm._v(" （六）在校期间无留校察看及以上的处分。 "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }